import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import styles from './Pricing.module.css';

const Pricing = () => {
  // Brand color variables
  const brandOrange = "#e87355";
  const brandBlue = "#5ba5e0";
  const brandPurple = "#a35b89";

  const plans = [
    {
      name: "Starter Plan",
      price: "₹7,500",
      duration: "/ Month",
      tagline: "Perfect for trying out AI",
      features: [
        "2 AI News Anchors (Male & Female)",
        "Daily limit 4 minutes news",
        "Ex: 2 mins के 2 वीडियो या 1 min के 4 वीडियो",
        "Green Screen & Studio Output",
        "Intro/Outro 3D Logo Free",
        "Promo Video Free"
      ],
      note: "*Editing services will be charged ₹4,000/month starting after 1 months.",
      buttonText: "Choose Starter",
         highlightFeature: "Editing Free for 1 Months",

      premium: false
    },
    {
      name: "Premium Plan",
      price: "₹12,000",
      duration: "/ Month",
      tagline: "Perfect for New Digital News Channels",
      features: [
        "4 AI News Anchors (Male & Female)",
        "Daily limit 10 minutes news",
        "Ex: 2 mins के 5 वीडियो या 3 mins के 3 वीडियो",
        "Green Screen & Studio Output",
        "Intro/Outro 3D Logo Free",
        "Promo Video Free",
      ],
      highlightFeature: "Editing Free for 1 Months",
      buttonText: "Choose Premium",
      premium: true,
      badge: "POPULAR",
      note: "*Editing services will be charged ₹4,000/month starting after 1 months.",
    },
    {
      name: "Anchors with your face & voice",
      price: "₹17,000",
      duration: "/ Month",
      tagline: "Your Personal AI News Anchor",
      features: [
        "AI Anchor with Your Face",
        "AI Anchor with Your Voice",
        "Custom Personal News Anchor",
        "Your Original Voice and Face",
      ],
      highlightFeature: "Editing Free for 1 Months",
      highlightColor: brandPurple,
      buttonText: "Create Custom AI",
      note: "*Editing services will be charged ₹4,000/month starting after 1 months.",
      premium: false
    }
  ];

  return (
    <section id="pricing" className={styles.pricing}>
      <h2 className={styles.sectionTitle}>
        Our <span className={styles.neonText}>Pricing Plans</span>
      </h2>
      
      <div className={styles.pricingGrid}>
        {plans.map((plan, index) => (
          <div 
            key={index} 
            className={`${styles.glassCard} ${styles.priceCard} ${plan.premium ? styles.premiumCard : ''}`}
          >
            {plan.badge && <div className={styles.popularBadge}>{plan.badge}</div>}
            
            <h3 className={styles.planName}>{plan.name}</h3>
            <div className={styles.planPrice}>{plan.price} <span>{plan.duration}</span></div>
            <p className={styles.planTagline}>{plan.tagline}</p>
            
            <ul className={styles.planFeatures}>
              {plan.features.map((feature, fIdx) => (
                <li key={fIdx}>
                  <CheckCircle2 size={20} color={brandBlue} /> {feature}
                </li>
              ))}
              {plan.highlightFeature && (
                <li>
                  <CheckCircle2 size={20} color={plan.highlightColor || brandOrange} />
                  <strong style={{ color: plan.highlightColor || brandOrange }}>
                    {plan.highlightFeature}
                  </strong>
                </li>
              )}
            </ul>

            <button className={plan.premium ? styles.btnPrimary : styles.btnSecondary}>
              {plan.buttonText}
            </button>
            
            {plan.note && <div className={styles.planNote}>{plan.note}</div>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Pricing;